import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

// Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCLMQObwEuX-0-8rLvxQpnC2ICeS0bgWeM",
  authDomain: "rapid-quiz-4c0e9.firebaseapp.com",
  databaseURL: "https://rapid-quiz-4c0e9-default-rtdb.firebaseio.com",
  projectId: "rapid-quiz-4c0e9",
  storageBucket: "rapid-quiz-4c0e9.firebasestorage.app",
  messagingSenderId: "850923304803",
  appId: "1:850923304803:web:eec57f6f063e653357c556",
  measurementId: "G-ZH50QET4ZQ"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services (removed unused getDatabase import)
export const auth = getAuth(app);
export const db = getFirestore(app);

export default app;
